import React from 'react'
import DemoInputsSection from '../DemoInputsSection'
import DemoInputCheckBoxSimple from './DemoInputCheckBoxSimple'

const DemoInputCheckBox = () => {

  return (
    <DemoInputsSection name="checkbox">
      <DemoInputCheckBoxSimple/>
    </DemoInputsSection>
  )
}

export default DemoInputCheckBox